/* eslint-disable @typescript-eslint/no-explicit-any */

import type { InternalUserSchedule } from '../../Scenario';

export function migrateScenarioAddPatchShipments(
  scenario: InternalUserSchedule & { patchShipments?: Map<any, any> },
): InternalUserSchedule {
  const patchShipments: InternalUserSchedule['patchShipments'] =
    scenario.patchShipments ?? new Map();

  // Make sure every shipmentId referred has an entry in patchShipments
  for (const [, { patch }] of scenario.patchOrders) {
    if (patch.shipmentId && !patchShipments.has(patch.shipmentId)) {
      patchShipments.set(patch.shipmentId, {
        voyageAttributeId: null,
      });
    }
  }

  return {
    ...scenario,
    patchShipments,
  };
}
